import React, { useEffect } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { FaBalanceScale, FaHandshake, FaUsers, FaShieldAlt } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";

const NedenBiz = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  const reasons = [
    {
      icon: <FaBalanceScale size={40} color="#123274" />,
      title: "Adil ve Etik Yaklaşım",
      description:
        "Hukukun temel ilkelerine sadık kalarak, müvekkillerimize adil ve etik çözümler sunuyoruz."
    },
    {
      icon: <FaHandshake size={40} color="#123274" />,
      title: "Güçlü İşbirlikleri",
      description:
        "Yerel ve uluslararası hukuk alanlarında geniş bir ağ ile müvekkillerimize destek sağlıyoruz."
    },
    {
      icon: <FaUsers size={40} color="#123274" />,
      title: "Uzman Kadro",
      description:
        "Deneyimli avukat ekibimiz, hukuki süreçlerde en iyi desteği vermek için yanınızda."
    },
    {
      icon: <FaShieldAlt size={40} color="#123274" />,
      title: "Güvenilirlik ve Gizlilik",
      description:
        "Müvekkillerimizin tüm bilgilerini yüksek güvenlik standartları ile koruyoruz."
    }
  ];

  return (
    <div style={{ backgroundColor: "#f8f9fa", padding: "50px 0" }}>
      <Container>
        {/* <h2
          className="text-center mb-5"
          style={{ color: "#123274", fontFamily: "Benguiat Regular" }}
          data-aos="fade-up"
        >
          Neden Bizi Seçmelisiniz?
        </h2> */}
        <Row>
          {reasons.map((reason, index) => (
            <Col md="3" key={index} data-aos="fade-up" data-aos-delay={index * 200}>
              <Card className="text-center shadow-sm border-0">
                <CardBody>
                  <div className="mb-3">{reason.icon}</div>
                  <h5 style={{ color: "#123274", fontWeight: "bold" }}>{reason.title}</h5>
                  <p style={{ fontSize: "15px", color: "#555" }}>{reason.description}</p>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default NedenBiz;